/**
 * Link to `target` (sign-in or pricing) that brings the user back to the page
 * they are on now. The query string is part of that page — /refine and
 * /results cannot render without theirs — so it rides along with the pathname.
 */
export function hrefReturningHere(target: string): string {
  const here = `${window.location.pathname}${window.location.search}`;
  return `${target}?redirect_url=${encodeURIComponent(here)}`;
}
